import { Box, Grid2, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Center } from "@mantine/core";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { CaseDetailsPanel } from "./_components/ticket-caseDetailsPanel";
import { TicketInfoPanel } from "./_components/ticket-infoPanel"
import { TicketListPanel } from "./_components/ticket-listPanel"
import { TicketActionPanel } from "./_components/ticket-actionPanel"
import { useParams } from "react-router";
import { TicketQueryPanel } from "./_components/ticket-queryPanel";



export const TicketClientView = () => {

    const [value, setValue] = useState("1");
    const { caseId } = useParams<{ caseId: string }>();
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    const [paymentDate, setPaymentDate] = useState<string>();
    const [invoiceNumber, setInvoiceNumber] = useState<string>();

    return (
        <>
            <Grid2 container spacing={1} p={2}>
                <Grid2 size={{ xs: 12, sm: 4, md: 3 }}>
                    <CaseDetailsPanel />
                    <TicketListPanel caseId={Number(caseId)} />
                </Grid2>

                <Grid2 size={{ xs: 12, sm: 8, md: 9 }}>
                    {/* <TabContext value={value}>*/}
                    {/* <Grid2 size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "left" }}>
                            <TabList onChange={handleChange} variant="fullWidth" sx={{

                                backgroundColor: "grey.100",
                                borderRadius: 1,
                                minHeight: 48,
                                "& .MuiTabs-indicator": {
                                    display: "none",
                                },
                                "& .MuiTab-root": {
                                    flex: 1,
                                    minHeight: "48px",
                                    fontWeight: 500,
                                    borderRadius: 1,
                                    "&.Mui-selected": {
                                        backgroundColor: "primary.main",
                                        color: "white",
                                    },
                                },
                            }}>

                                <Tab label="Ticket Detail" value="1" />
                                <Tab label="Ticket History" value="2" />
                            </TabList>

                        </Grid2>*/}
                    <Grid2 container spacing={1}>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <TicketInfoPanel setPaymentDate={setPaymentDate} setInvoiceNumber={setInvoiceNumber} />
                        </Grid2>

                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <TicketActionPanel />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <TicketQueryPanel />
                        </Grid2>
                    </Grid2>

                    {  /*  </TabContext > */}
                </Grid2>
            </Grid2>
        </>
    );
};